export { default as WarehouseEdit } from './WarehouseEdit';
export { default as WarehouseList } from './WarehouseList';



// WEBPACK FOOTER //
// ./src/modules/warehouse/pages/index.js